'use client'

import { Button } from '@populix/pop-ui'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useCallback, useEffect } from 'react'

type TBackToSurveyListButtonProps = {
  variant?: 'button' | 'text'
}

export default function BackToSurveyListButton({
  variant = 'button',
}: TBackToSurveyListButtonProps) {
  const { push } = useRouter()

  const handlePopState = useCallback((event: PopStateEvent) => {
    event.preventDefault()
    window.history.replaceState(null, '', window.location.href)

    return window.location.replace('/')
  }, [])

  useEffect(() => {
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [handlePopState])

  return (
    <div className='flex min-w-[320px] justify-center'>
      {variant === 'button' ? (
        <Button
          type='button'
          variant='contained'
          color='primary'
          onClick={() => push('/')}
          aria-label='Back to Survey List'
        >
          Back to Survey List
        </Button>
      ) : (
        <Link href='/' className='text-center text-sm text-brand-light-blue underline'>
          Back to Survey List
        </Link>
      )}
    </div>
  )
}
